/// <amd-module name="Build/SourceProviders/Constants" />

export const ShortenedCommitHashLength = 8;